import { Container, Carousel } from "react-bootstrap";
import { useState, useEffect } from "react";
import BoxSimulationMobile from "./Components/BoxMobile/BoxSimulationMobile";
import BoxSimulationMobileHighlight from "./Components/BoxMobile/BoxSimulationMobileHighlight";
import useStore from "../../Zustand/Zustand";
import "./SimulationBanks.css";
import formatToNumber from "../../Utils/formartToNumber";
import formatToReal from "../../Utils/fomartToReal";

const SimulationBanks = (props) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const simulacoes = useStore((state) => state.simulacoes);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (simulacoes.length > 0 && simulacoes[0].length > 0) {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [simulacoes]);

  function verificarPalavras(texto) {
    switch (texto) {
      case "https://storage.googleapis.com/horus-storage/bank/bradesco.png":
        return "./assets/bradesco.svg";
      case "https://storage.googleapis.com/horus-storage/bank/caixa.png":
        return "./assets/caixa.svg";
      case "https://storage.googleapis.com/horus-storage/bank/brb.png":
        return "./assets/brb.svg";
      case "https://storage.googleapis.com/horus-storage/bank/santander.png":
        return "./assets/santander.svg";
      case "https://storage.googleapis.com/horus-storage/bank/itau.png":
        return "./assets/itau.svg";
      case "https://storage.googleapis.com/horus-storage/bank/logo_inter.png":
        return "./assets/inter.svg";
      default:
        return "Não reconhecido";
    }
  }

  const groupSimulations = (simulations, groupSize) => {
    let groups = [];
    for (let i = 0; i < simulations.length; i += groupSize) {
      groups.push(simulations.slice(i, i + groupSize));
    }
    return groups;
  };

  const sortedSimulations = (simulacoes[0] || []).sort(
    (a, b) => a.taxaEfetiva - b.taxaEfetiva
  );

  const menorTaxa =
    sortedSimulations.length > 0 ? sortedSimulations[0].taxaEfetiva : null;

  const groupSize = isSmallScreen ? 1 : 3;
  const groupedSimulations = groupSimulations(sortedSimulations, groupSize);

  return (
    <>
      <Container
        className="d-flex flex-nowrap mt-3 w-80 d-none d-md-block"
        style={{ maxWidth: "90%" }}
      >
        <Carousel
          slide={true}
          indicators={false}
          controls={true}
          touch={true}
          variant="dark"
          className="custom-carousel"
        >
          {groupedSimulations.length > 0 ? (
            groupedSimulations.map((group, groupIndex) => (
              <Carousel.Item key={groupIndex}>
                <div className="mt-2 d-flex justify-content-around w-100 ">
                  {group.map((simulacao, index) => {
                    const isLowestRate = simulacao.taxaEfetiva === menorTaxa;
                    const BoxComponent = isLowestRate
                      ? BoxSimulationMobileHighlight
                      : BoxSimulationMobile;

                    return (
                      <BoxComponent
                        key={index}
                        id={simulacao.idSimulacao}
                        src={verificarPalavras(simulacao.logoBanco)}
                        relation={simulacao.relacionamento}
                        tax={simulacao.taxaEfetiva}
                        term={simulacao.prazo}
                        firstInstallment={formatToReal(
                          simulacao.valorPrimeiraParcela
                        )}
                        lastInstallment={formatToReal(
                          simulacao.valorUltimaParcela
                        )}
                        effectiveRate={simulacao.taxaEfetiva}
                        insuranceCompany={simulacao.seguradora}
                        cet={formatToNumber(simulacao.cet) + "%"}
                        color={props.color}
                      />
                    );
                  })}
                </div>
              </Carousel.Item>
            ))
          ) : (
            <p style={{ margin: "0 auto", textAlign: "center" }}>
              Nenhuma simulação encontrada.
            </p>
          )}
        </Carousel>
      </Container>

      <div className="d-md-none m-0">
        <div
          className="d-flex m-0 p-0 text-center"
          style={{ maxWidth: "100%", overflowX: "hidden" }}
        >
          <Carousel
            slide={true}
            indicators={false}
            controls={true}
            touch={true}
            variant="dark"
          >
            {groupedSimulations.length > 0 ? (
              groupedSimulations.map((group, groupIndex) => (
                <Carousel.Item key={groupIndex}>
                  <div className="d-flex justify-content-center ">
                    {group.map((simulacao, index) => {
                      const isLowestRate = simulacao.taxaEfetiva === menorTaxa;
                      const BoxComponent = isLowestRate
                        ? BoxSimulationMobileHighlight
                        : BoxSimulationMobile;
                      return (
                        <BoxComponent
                          key={index}
                          id={simulacao.idSimulacao}
                          src={verificarPalavras(simulacao.logoBanco)}
                          relation={simulacao.relacionamento}
                          tax={simulacao.taxaEfetiva}
                          term={simulacao.prazo}
                          firstInstallment={formatToReal(
                            simulacao.valorPrimeiraParcela
                          )}
                          lastInstallment={formatToReal(
                            simulacao.valorUltimaParcela
                          )}
                          effectiveRate={simulacao.taxaEfetiva}
                          insuranceCompany={simulacao.seguradora}
                          cet={formatToNumber(simulacao.cet) + "%"}
                          color={props.color}
                        />
                      );
                    })}
                  </div>
                </Carousel.Item>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px",
                }}
              >
                <p style={{ margin: "0 auto", textAlign: "center" }}>
                  Nenhuma simulação encontrada.
                </p>
              </div>
            )}
          </Carousel>
        </div>
      </div>
    </>
  );
};

export default SimulationBanks;
